import axios from 'axios';

import axiosMonitorAPI from './axiosMonitorAPI';

import { AgroModelOutcome } from '../models/AgroModel';
import { AvgStats } from '../models/AvgStats';
import { DigitalHelper } from '../models/DigitalHelper';
import { Graph } from '../models/Graph';
import { FieldState } from '../models/FieldState';
import { FieldReport } from '../models/FieldReport';
import { FieldSummary } from '../models/FieldsSummary';
import { LiveStation } from '../models/StationsLive';
import { WeatherModel } from '../models/WeatherModel';

export class MonitorAPI {
    GetLastMetrics(zondNumberInDB: string): Promise<Graph[]> {
        return new Promise((resolve, reject) => {
            axiosMonitorAPI
                .get(`/get_last_metrics/${zondNumberInDB}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetMetrics(zondNumberInDB: string, startDate: number, endDate: number): Promise<Graph[]> {
        return new Promise((resolve, reject) => {
            axiosMonitorAPI
                .get(`/get_metrics?number_in_db=${zondNumberInDB}&from=${startDate}&to=${endDate}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetMetricsWithFunction(
        zondNumberInDB: string,
        startDate: number,
        endDate: number,
        func: string,
        tz: string,
    ): Promise<Graph[]> {
        return new Promise((resolve, reject) => {
            axiosMonitorAPI
                .get(
                    `/get_metrics/${func}?number_in_db=${zondNumberInDB}&start_date=${startDate}&end_date=${endDate}&tz=${tz}`,
                )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetMetricsWithFunctionRaw(zondNumberInDB: string, startDate: number, endDate: number, func: string): Promise<any> {
        return new Promise((resolve, reject) => {
            axiosMonitorAPI
                .get(
                    `/get_metrics_with_function/raw/${func}?number_in_db=${zondNumberInDB}&start_date=${startDate}&end_date=${endDate}`,
                )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetDigitalHelperMetrics(zondNumberInDB: string, startDate: number, endDate: number): Promise<DigitalHelper> {
        return new Promise((resolve, reject) => {
            axiosMonitorAPI
                .get(`/digital_helper?number_in_db=${zondNumberInDB}&start_date=${startDate}&end_date=${endDate}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetFieldState(fieldId: number): Promise<FieldState> {
        return new Promise((resolve, reject) => {
            axiosMonitorAPI
                .get(`/field_state?field_id=${fieldId}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetFieldReport(fieldId: number, season?: number): Promise<FieldReport> {
        const seasonParam = season ? `&season=${season}` : '';
        return new Promise((resolve, reject) => {
            axiosMonitorAPI
                .get(`/field_report?field_id=${fieldId}${seasonParam}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetFieldsSummary(): Promise<FieldSummary[]> {
        return new Promise((resolve, reject) => {
            axiosMonitorAPI
                .get('/fields_summary')
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetStationsLive(): Promise<LiveStation[]> {
        return new Promise((resolve, reject) => {
            axiosMonitorAPI
                .get('/stations_live')
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetWeather(zondNumberInDB: string): Promise<WeatherModel> {
        return new Promise((resolve, reject) => {
            axiosMonitorAPI
                .get(`/get_weather/${zondNumberInDB}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetAgroModelOutcome(link: string, selectedZond: string, startDate: string): Promise<AgroModelOutcome> {
        let URL = startDate ? `${link}?zond=${selectedZond}&start=${startDate}` : `${link}?zond=${selectedZond}`;
        return new Promise((resolve, reject) => {
            axios
                .get(URL)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }
}

export const monitorAPI = new MonitorAPI();
